module.exports = __webpack_public_path__ + "static/img/dynamice.9c3a3e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamice.png
// module id = TTyU
// module chunks = 45